
import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import SearchControls from './SearchControls';
import SearchRow from './SearchRow';

// Utils

import { adjustSearchInputsDefaultValues } from '../../../utils/miscellaneous/adjustSearchInputsDefaultValues';
import { executeCallbacks } from '../../../utils/miscellaneous/executeCallbacks';
import { getSearchConfig } from '../../../constants/ticketMgmt/manage-assignees/searchConfig';

// Constants

import { BOUND_PARAMS } from '../../../constants/ticketMgmt/manage-assignees/searchTypes';
import { configs } from '../../../constants/configs/configs';
import {
    MANDATORY_INPUT_NAMES_FOR_DATE_SEARCH,
    SEARCH_INPUT_DEFAULTS,
    SEARCH_INPUT_NAMES
} from '../../../constants/ticketMgmt/manage-assignees/searchTypes';
import { useLocation, useNavigate } from 'react-router-dom';


const AssigneesSearch = props => {

    const {
        getAssignees,
        lists,
        searchValues,
        updateAssignees,
        updateSearchValues
    } = props;

    const navigate = useNavigate();
    const location = useLocation();

    const handleInputChange = ({ name, value }) => {
        updateSearchValues(prevState => {
            const nextState = {
                ...prevState,
                [ name ]: value
            };
            return {
                ...nextState,
                ...(
                    MANDATORY_INPUT_NAMES_FOR_DATE_SEARCH.every(inputName => !nextState[inputName]) ?
                        {
                            [ SEARCH_INPUT_NAMES.AFTER_DATE ]: SEARCH_INPUT_DEFAULTS[SEARCH_INPUT_NAMES.AFTER_DATE],
                            [ SEARCH_INPUT_NAMES.BEFORE_DATE ]: SEARCH_INPUT_DEFAULTS[SEARCH_INPUT_NAMES.BEFORE_DATE]
                        } :
                        {}
                )
            };
        });
    };

    const [ refresher, updateRefresher ] = useState(0);

    useEffect(() => {
        if(refresher) {
            updateSearchValues(adjustSearchInputsDefaultValues());
        }
    }, [ refresher ]);

    const searchConfig = useMemo(
        () => getSearchConfig(lists),
        [ lists ]
    );

    const getSearchInputs = () => {
        return searchConfig.map((rowData, idx) => {
            return (
                <SearchRow
                    key = { idx }
                    handleInputChange = { handleInputChange }
                    refresher = { refresher }
                    rowData = { rowData }
                    searchValues = { searchValues }
                />
            );
        });
    };

    const refresh = () => {
        updateRefresher(v => v + 1);
        updateAssignees([]);
    };

    const searchParams = useMemo(
        () => {
            const concatParam = (searchParams, key, value) => {
                return `${!searchParams ? searchParams : `${searchParams}&`}${key}=${value}`;
            };

            return Object.entries({ ...searchValues })
                .reduce((searchParams, [ key, value ]) => {

                    const rule = BOUND_PARAMS.find(([ n ]) => n === key);

                    if(!rule) {
                        return !value ? searchParams : concatParam(searchParams, key, value);
                    } else {
                        const [ , param2 ] = rule;
                        if(!searchValues[ param2 ]) {
                            return searchParams;
                        } else {
                            return concatParam(searchParams, key, value);
                        }
                    }
                }, '');
        },
        [ searchValues ]
    );

    const makeRequest = cb => {
        if(searchParams) {
            getAssignees(searchParams)
                .then(assignees => {
                    if(assignees) {
                        updateAssignees(assignees);
                    }
                    executeCallbacks(cb);
                });
        }
    };

    useEffect(() => {
        const { value } = location?.state || {};  

        const clearState = () => {
            navigate(
                configs.routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
                { state: {} }
            );
        };

        if(value !== undefined) makeRequest(clearState);
    }, [ ]);

    return (
        <div className = 'assignee-section gi-panel'>
            <h3>
                <FormattedMessage id = 'search.header'/>
            </h3>
            { getSearchInputs() }
            <SearchControls
                { ...{
                    makeRequest,
                    searchParams,
                    refresh
                } }
            />
        </div>
    );
};

export default AssigneesSearch;